/* ==========================================================================
   THE TOMATO MAN — Shopify Theme JavaScript
   Replaces Framer Motion & React state
   ========================================================================== */

(function () {
  'use strict';

  /* --------------------------------------------------------------------------
     1. Scroll-Reveal (IntersectionObserver)
     Replaces Framer Motion's whileInView
     -------------------------------------------------------------------------- */
  function initReveal() {
    var elements = document.querySelectorAll('.reveal');
    if (!elements.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '-100px 0px', threshold: 0 }
    );

    elements.forEach(function (el) {
      observer.observe(el);
    });
  }

  /* --------------------------------------------------------------------------
     2. Chef Moments Slideshow
     Auto-rotating pairs of images every 4s with dot navigation
     -------------------------------------------------------------------------- */
  function initChefMoments() {
    var container = document.querySelector('[data-chef-moments]');
    if (!container) return;

    var leftSlide = container.querySelector('[data-slide="left"]');
    var rightSlide = container.querySelector('[data-slide="right"]');
    if (!leftSlide || !rightSlide) return;

    var leftImages = leftSlide.querySelectorAll('.chef-moments__img');
    var rightImages = rightSlide.querySelectorAll('.chef-moments__img');
    var dots = container.querySelectorAll('.chef-moments__dot');
    var totalPairs = dots.length;
    var currentIndex = 0;
    var timer;

    function showPair(index) {
      // Update left images
      leftImages.forEach(function (img, i) {
        img.classList.toggle('is-active', i === index);
      });
      // Update right images
      rightImages.forEach(function (img, i) {
        img.classList.toggle('is-active', i === index);
      });
      // Update dots
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
      currentIndex = index;
    }

    function next() {
      showPair((currentIndex + 1) % totalPairs);
    }

    function startTimer() {
      clearInterval(timer);
      timer = setInterval(next, 4000);
    }

    // Dot click handlers
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        showPair(i);
        startTimer(); // Reset timer on manual navigation
      });
    });

    // Initialize
    showPair(0);
    startTimer();
  }

  /* --------------------------------------------------------------------------
     4. Cart Drawer Toggle
     Open/close logic for the cart sidebar
     -------------------------------------------------------------------------- */
  function initCartDrawer() {
    var openBtns = document.querySelectorAll('[data-cart-open]');
    var closeElements = document.querySelectorAll('[data-cart-close]');
    
    function openDrawer(e) {
      if (e) e.preventDefault();
      document.body.classList.add('cart-is-open');
    }
    
    function closeDrawer(e) {
      if (e) e.preventDefault();
      document.body.classList.remove('cart-is-open');
    }
    
    openBtns.forEach(function(btn) {
      btn.addEventListener('click', openDrawer);
    });
    
    closeElements.forEach(function(el) {
      el.addEventListener('click', closeDrawer);
    });

    // Make functions globally available for AJAX updates if needed
    window.openCartDrawer = openDrawer;
  }

  /* --------------------------------------------------------------------------
     5. AJAX Add to Cart
     Intercept standard form submissions to keep user on same page
     -------------------------------------------------------------------------- */
  function initAjaxCart() {
    var addToCartForms = document.querySelectorAll('form[action="/cart/add"]');

    addToCartForms.forEach(function(form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        var submitBtn = form.querySelector('[type="submit"]');
        var originalText = submitBtn ? submitBtn.innerText : '';
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.innerText = 'Adding...';
        }

        var formData = new FormData(form);
        if (submitBtn && submitBtn.innerText.toLowerCase().includes('pre-book') && !formData.has('properties[_preorder]')) {
          formData.append('properties[_preorder]', 'true');
        }

        fetch(getRoot() + 'cart/add.js', {
          method: 'POST',
          body: formData
        })
        .then(function(response) {
          return response.json();
        })
        .then(function() {
          // Trigger section rendering for cart and fetch update
          updateCartUI();
        })
        .catch(function(error) {
          console.error('Error:', error);
          alert('There was an issue adding this item to your cart.');
        })
        .finally(function() {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.innerText = originalText;
          }
        });
      });
    });
  }

  // Helper to safely get root route
  function getRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
  }

  // Update Cart via Section Rendering API & Cart API
  function updateCartUI() {
    fetch(getRoot() + '?section_id=cart-drawer')
      .then(function(res) { return res.text(); })
      .then(function(text) {
        // Parse section HTML
        var html = new DOMParser().parseFromString(text, 'text/html');
        var newDrawer = html.querySelector('[data-cart-drawer]');
        var oldDrawer = document.querySelector('[data-cart-drawer]');
        
        if (newDrawer && oldDrawer) {
          oldDrawer.innerHTML = newDrawer.innerHTML;
          // Re-bind close triggers safely
          var closeBtns = document.querySelectorAll('.cart-drawer__close, [data-cart-close]');
          closeBtns.forEach(function(btn) {
            btn.addEventListener('click', function(e) {
              e.preventDefault();
              document.body.classList.remove('cart-is-open');
            });
          });
          // Re-bind quantity change triggers
          bindCartChangeEvents();
        }
      })
      .then(function() {
        // Update header count
        return fetch(getRoot() + 'cart.js');
      })
      .then(function(res) { return res.json(); })
      .then(function(cart) {
        var countBubbles = document.querySelectorAll('[data-cart-count]');
        countBubbles.forEach(function(bubble) {
          bubble.innerText = cart.item_count;
        });
        
        // Ensure routes object is defined
        if (window.openCartDrawer) {
          window.openCartDrawer();
        } else {
          document.body.classList.add('cart-is-open');
        }
      })
      .catch(function(err) { console.error('Cart update error:', err); });
  }

  function bindCartChangeEvents() {
    var changeElements = document.querySelectorAll('[data-cart-change]');
    
    changeElements.forEach(function(el) {
      // Remove any existing identical listener to avoid duplicates if re-binding fails partially
      var updatedEl = el.cloneNode(true);
      if (el.parentNode) {
        el.parentNode.replaceChild(updatedEl, el);
      }
      
      updatedEl.addEventListener('click', function(e) {
        e.preventDefault();
        var id = this.getAttribute('data-cart-change');
        var qty = this.getAttribute('data-qty');
        
        if (!id || qty === null) return;
        
        // Prevent spam clicking
        this.disabled = true;
        this.style.opacity = '0.5';

        fetch(getRoot() + 'cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            line: parseInt(id, 10),
            quantity: parseInt(qty, 10)
          })
        })
        .then(function(res) { return res.json(); })
        .then(function(cart) {
          updateCartUI();
        })
        .catch(function(err) {
          console.error('Cart change error:', err);
          updatedEl.disabled = false;
          updatedEl.style.opacity = '1';
        });
      });
    });
  }

  /* --------------------------------------------------------------------------
     6. Mobile Navigation (Hamburger Menu)
     -------------------------------------------------------------------------- */
  function initMobileNav() {
    var hamburger = document.getElementById('navbar-hamburger');
    var closeBtn = document.getElementById('mobile-nav-close');
    var overlay = document.getElementById('mobile-nav-overlay');
    var mobileNav = document.getElementById('mobile-nav');
    var mobileLinks = document.querySelectorAll('.mobile-nav__link, .mobile-nav__actions .btn');

    if (!hamburger || !mobileNav) return;

    function openNav() {
      document.body.classList.add('mobile-nav-is-open');
      hamburger.setAttribute('aria-expanded', 'true');
      mobileNav.setAttribute('aria-hidden', 'false');
      if (overlay) overlay.setAttribute('aria-hidden', 'false');
    }

    function closeNav() {
      document.body.classList.remove('mobile-nav-is-open');
      hamburger.setAttribute('aria-expanded', 'false');
      mobileNav.setAttribute('aria-hidden', 'true');
      if (overlay) overlay.setAttribute('aria-hidden', 'true');
    }

    hamburger.addEventListener('click', function() {
      if (document.body.classList.contains('mobile-nav-is-open')) {
        closeNav();
      } else {
        openNav();
      }
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', closeNav);
    }

    if (overlay) {
      overlay.addEventListener('click', closeNav);
    }

    // Close when a nav link is tapped
    mobileLinks.forEach(function(link) {
      link.addEventListener('click', closeNav);
    });

    // Close on Escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && document.body.classList.contains('mobile-nav-is-open')) {
        closeNav();
        hamburger.focus();
      }
    });
  }

  /* --------------------------------------------------------------------------
     5. Initialize all on DOM ready
     -------------------------------------------------------------------------- */
  function init() {
    initReveal();
    initChefMoments();
    initCartDrawer();
    initAjaxCart();
    bindCartChangeEvents();
    initMobileNav();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
